import { useCallback, useEffect, useState } from 'react';
import api from 'services/api';
import { PixInfo, Transacao } from './PaymentPage.types';

export const usePaymentPageRules = (transacaoId?: string) => {
  const [transacao, setTransacao] = useState<Transacao | null>(null);
  const [pixInfo, setPixInfo] = useState<PixInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const carregarTransacao = useCallback(async () => {
    if (!transacaoId) {
      setError('Transação não encontrada');
      setLoading(false);
      return;
    }

    try {
      const response = await api.get(`/transacoes/${transacaoId}`);
      setTransacao(response.data.transacao);
      setPixInfo(response.data.pix);
      setError('');
    } catch (err) {
      setError('Transação não encontrada');
    } finally {
      setLoading(false);
    }
  }, [transacaoId]);

  useEffect(() => {
    void carregarTransacao();
  }, [carregarTransacao]);

  return {
    transacao,
    pixInfo,
    loading,
    error,
    carregarTransacao,
    setError,
  };
};

export type UsePaymentPageRulesReturn = ReturnType<typeof usePaymentPageRules>;
